import { render } from "./TheNotificationArea.vue?vue&type=template&id=9284922c&scoped=true&ts=true"
import script from "./TheNotificationArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationArea.vue?vue&type=script&lang=ts"

import "./TheNotificationArea.vue?vue&type=style&index=0&id=9284922c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9284922c"]])

export default __exports__